import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { ReactNode } from 'react';
import { ModalWrapper, SectionTitle } from '../../shared/components';

/** Title, body and Cancel/primary buttons — the frame every task dialog shares. */
export default function DialogShell({
  open,
  title,
  onClose,
  onSubmit,
  submitLabel = 'Save',
  submitColor = 'primary',
  busy,
  disabled,
  maxWidth = 'sm',
  children,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  submitColor?: 'primary' | 'error' | 'warning' | 'success';
  busy?: boolean;
  disabled?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  children: ReactNode;
}) {
  return (
    <ModalWrapper open={open} onClose={busy ? () => {} : onClose} maxWidth={maxWidth} sx={{ overflowY: 'auto' }}>
      <SectionTitle title={title} />
      <Stack gap={2}>{children}</Stack>
      <Stack direction='row' justifyContent='flex-end' gap={1}>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button variant='contained' color={submitColor} onClick={onSubmit} disabled={busy || disabled}>
          {busy ? 'Saving…' : submitLabel}
        </Button>
      </Stack>
    </ModalWrapper>
  );
}
